/**
 * LUNAIRE v4 — Interaction Layer
 * Sticky ATC (name + sale price + compare price | button)
 * Scroll reveal · Parallax · Header scroll · Right-click disable
 */
!function () {
  'use strict';
  var noMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function onReady(fn) {
    document.readyState !== 'loading' ? fn() : document.addEventListener('DOMContentLoaded', fn);
  }

  /* ── 1. HEADER SCROLL STATE ─────────────────────────────────── */
  function initHeader() {
    var hw = document.querySelector('.header-wrapper');
    if (!hw) return;
    var tick = false;
    window.addEventListener('scroll', function () {
      if (tick) return;
      requestAnimationFrame(function () {
        hw.dataset.scrolled = window.scrollY > 10 ? 'true' : 'false';
        tick = false;
      });
      tick = true;
    }, { passive: true });
  }

  /* ── 2. STICKY ATC — name + sale/compare prices | button ─────── */
  function initStickyATC() {
    var nativeBtn = document.querySelector('.product-form__submit, [name="add"]');
    if (!nativeBtn) return;

    // Product name
    var nameEl = document.querySelector('.product__title h1');
    var name = nameEl ? nameEl.textContent.trim() : '';
    if (name.length > 48) name = name.slice(0, 48) + '…';

    // Prices — find sale and compare-at
    var saleEl    = document.querySelector('.price__sale .price-item--sale, .price__sale .price-item--last');
    var regularEl = document.querySelector('.price__regular .price-item--regular');
    var compareEl = document.querySelector('.price__sale .price-item--regular s, .price__sale s');

    var salePrice    = saleEl    ? saleEl.textContent.trim()    : (regularEl ? regularEl.textContent.trim() : '');
    var comparePrice = compareEl ? compareEl.textContent.trim() : '';
    // If no sale, just use regular
    if (!salePrice && regularEl) salePrice = regularEl.textContent.trim();

    // Build bar
    var bar = document.createElement('div');
    bar.id = 'ln-atc';
    bar.setAttribute('aria-hidden', 'true');
    bar.innerHTML =
      '<div class="ln-atc-left">' +
        '<span class="ln-atc-name">' + name + '</span>' +
        '<div class="ln-atc-prices">' +
          '<span class="ln-atc-price-sale">' + salePrice + '</span>' +
          (comparePrice ? '<span class="ln-atc-price-compare">' + comparePrice + '</span>' : '') +
        '</div>' +
      '</div>' +
      '<button class="ln-atc-btn" type="button">Add to Cart</button>';
    document.body.appendChild(bar);

    // Wire to real ATC
    bar.querySelector('.ln-atc-btn').addEventListener('click', function () {
      var btn = document.querySelector('.product-form__submit, [name="add"]');
      if (btn && !btn.disabled) btn.click();
    });

    // Show/hide on native button visibility
    // Also hide when cart drawer is open
    function updateBarVisibility(nativeBtnVisible) {
      var cartDrawerOpen = document.querySelector('cart-drawer.active') !== null
        || document.body.classList.contains('overflow-hidden');
      var shouldShow = !nativeBtnVisible && !cartDrawerOpen;
      bar.classList.toggle('show', shouldShow);
      bar.setAttribute('aria-hidden', String(!shouldShow));
    }

    var nativeBtnVisible = true;
    if (window.IntersectionObserver) {
      new IntersectionObserver(function (entries) {
        nativeBtnVisible = entries[0].isIntersecting;
        updateBarVisibility(nativeBtnVisible);
      }, { threshold: 0 }).observe(nativeBtn);
    }

    // Watch for cart drawer open/close
    // Dawn adds 'active' to cart-drawer AND 'overflow-hidden' to body when drawer opens
    var cartDrawerEl = document.querySelector('cart-drawer');
    if (cartDrawerEl) {
      var drawerObserver = new MutationObserver(function() {
        updateBarVisibility(nativeBtnVisible);
      });
      drawerObserver.observe(cartDrawerEl, { attributes: true, attributeFilter: ['class'] });
    }

    // Also watch body for overflow-hidden (added synchronously before setTimeout in Dawn)
    var bodyObserver = new MutationObserver(function() {
      updateBarVisibility(nativeBtnVisible);
    });
    bodyObserver.observe(document.body, { attributes: true, attributeFilter: ['class'] });

    // Also listen for custom Shopify cart events
    document.addEventListener('cart:open', function() {
      updateBarVisibility(nativeBtnVisible);
    });
    document.addEventListener('cart:close', function() {
      updateBarVisibility(nativeBtnVisible);
    });

    // Sync prices on variant change
    document.addEventListener('variant:changed', function (e) {
      var v = e.detail && e.detail.variant;
      if (!v) return;
      var fmt = function(cents) {
        return window.Shopify && Shopify.formatMoney
          ? Shopify.formatMoney(cents, Shopify.money_format || '${{amount}}')
          : '$' + (cents / 100).toFixed(2);
      };
      var salePriceSpan = bar.querySelector('.ln-atc-price-sale');
      var comparePriceSpan = bar.querySelector('.ln-atc-price-compare');
      if (salePriceSpan) salePriceSpan.textContent = fmt(v.price);
      if (comparePriceSpan && v.compare_at_price && v.compare_at_price > v.price) {
        comparePriceSpan.textContent = fmt(v.compare_at_price);
        comparePriceSpan.style.display = '';
      } else if (comparePriceSpan) {
        comparePriceSpan.style.display = 'none';
      }
    });
  }

  /* ── 3. SCROLL REVEAL ───────────────────────────────────────── */
  function initReveal() {
    if (noMotion || !window.IntersectionObserver) return;
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) { e.target.classList.add('ln-in'); io.unobserve(e.target); }
      });
    }, { threshold: 0.08, rootMargin: '0px 0px -32px 0px' });

    var targets = [
      { sel: '.rich-text__wrapper',            delay: 0 },
      { sel: '.image-with-text__content',      delay: 0 },
      { sel: '.image-with-text__media-item',   delay: 0 },
      { sel: '.newsletter__wrapper',            delay: 0 },
      { sel: '.collapsible-content__header',   delay: 0 },
      { sel: '.banner__box',                   delay: 0 },
    ];
    targets.forEach(function (t) {
      document.querySelectorAll(t.sel).forEach(function (el) {
        el.classList.add('ln-up');
        io.observe(el);
      });
    });

    // Stagger multicolumn items
    document.querySelectorAll('.multicolumn-list__item').forEach(function (el, i) {
      el.classList.add('ln-up', 'ln-up-d' + Math.min(i + 1, 5));
      io.observe(el);
    });

    document.querySelectorAll('.ln-up').forEach(function (el) { io.observe(el); });
  }

  /* ── 4. HERO PARALLAX ───────────────────────────────────────── */
  function initParallax() {
    if (noMotion) return;
    var imgs = document.querySelectorAll('.banner__media img');
    if (!imgs.length) return;
    var tick = false;
    window.addEventListener('scroll', function () {
      if (tick) return;
      requestAnimationFrame(function () {
        imgs.forEach(function (img) {
          var banner = img.closest('.banner');
          if (!banner) return;
          var rect = banner.getBoundingClientRect();
          if (rect.bottom < 0 || rect.top > window.innerHeight) return;
          img.style.transform = 'translateY(' + (window.scrollY * 0.15).toFixed(1) + 'px)';
        });
        tick = false;
      });
      tick = true;
    }, { passive: true });
  }

  /* ── 5. BANNER ENTRANCE ANIMATION ──────────────────────────── */
  function initHeroEntrance() {
    if (noMotion) return;
    ['.banner__heading', '.banner__text', '.banner__buttons'].forEach(function (sel, i) {
      var el = document.querySelector(sel);
      if (!el) return;
      el.style.cssText = 'opacity:0;transform:translateY(16px);transition:opacity 0.75s cubic-bezier(0,0,0.2,1),transform 0.75s cubic-bezier(0,0,0.2,1);transition-delay:' + (0.18 + i * 0.1) + 's';
      setTimeout(function () { el.style.opacity = '1'; el.style.transform = 'none'; }, 80);
    });
  }

  /* ── 6. RIGHT-CLICK DISABLE ─────────────────────────────────── */
  document.addEventListener('contextmenu', function (e) { e.preventDefault(); });

  /* ── 7. LAZY IMAGE FADE ─────────────────────────────────────── */
  function initLazyFade() {
    document.querySelectorAll('img[loading="lazy"]').forEach(function (img) {
      if (!img.complete) {
        img.style.opacity = '0';
        img.style.transition = 'opacity 0.4s ease';
        img.addEventListener('load', function () { img.style.opacity = '1'; }, { once: true });
      }
    });
  }

  /* ── INIT ───────────────────────────────────────────────────── */
  onReady(function () {
    initHeader();
    initStickyATC();
    initLazyFade();
    if (!noMotion) {
      initReveal();
      initParallax();
      initHeroEntrance();
    }
  });

}();
